import { Configuration, PopupRequest, SilentRequest } from "@azure/msal-browser";

const azureClientId = process.env.REACT_APP_AZURE_CLIENT_ID!;
const defaultApiScope = `api://${azureClientId}/access_as_user`;

export const graphScopes = ["User.Read"];
export const apiScopes = [
  process.env.REACT_APP_REDACTOR_API_SCOPE || defaultApiScope,
];

export const msalConfig: Configuration = {
  auth: {
    clientId: azureClientId,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID!}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // AUTH-001 hardening: bearer tokens used to be persisted in
    // localStorage, which kept them readable by injected script across
    // tabs and browser restarts. `sessionStorage` scopes the cache to
    // the current tab and clears on close, materially shrinking the
    // XSS blast radius. Users will need to authenticate again at the
    // start of each browser session, which matches the SPA's
    // production deployment posture (Entra-internal, MSAL popup).
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        console.log(`[MSAL] ${message}`);
      },
      logLevel: 1, // Error and Warning levels
      piiLoggingEnabled: false,
    },
  },
};

// Backend API calls must use the Redactor API scope. Graph calls request their
// own Graph token separately when needed.
export const loginRequest: PopupRequest = {
  scopes: [...apiScopes, "openid", "profile"],
  prompt: "select_account",
};

export const redirectRequest = {
  scopes: apiScopes,
};

export const silentRequest: SilentRequest = {
  scopes: apiScopes,
};
